import { atomFamily } from "jotai/utils";

import { Event } from "types/Event";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

export const sessionEventStackAtom = atomFamily((sessionId: string) =>
  createPersistedAtom<Event[]>(`eventStack-${sessionId}`, [])
);

export const eventStackAtom = createDerivedSessionAtom<Event[]>(sessionEventStackAtom);
